var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.549 18.628V.632h17.62L8.55 18.627ZM17.947 11.373v17.995H.326l17.62-17.995ZM19.591 25.932a3.35 3.35 0 0 0 1.653 2.9l-.008.017.074.02c.448.247.96.393 1.503.404h5.378l-2.349-4.798-.001-.002a3.286 3.286 0 0 0-2.96-1.883c-1.817 0-3.29 1.497-3.29 3.342Z",
    fill: "#D6FD51"
  })));
};
export default SvgLogo;